import React from 'react';
import clsx from 'clsx';

import { Template } from '../../templates';
import { GetTemplateButton } from '../../controls/get-template-button';
import styles from './template-card.scss';

interface TemplateCardProps {
  disabled?: boolean;
  onOpenTemplate?: () => void;
  template: Template;
}

export const TemplateCard = ({ disabled, onOpenTemplate, template }: TemplateCardProps) => {
  return (
    <div className={clsx(styles.card, styles.templateCard)}>
      <div className={styles.templateTitle}>
        <h3 className="uiTypeHeader">{template.title}</h3>
        {template.icon}
      </div>
      <p>{template.desc}</p>
      <GetTemplateButton disabled={disabled} onClick={onOpenTemplate} />
    </div>
  );
};
